import { CoreApi } from '@inter-ikea-storageone/range';
import { default as Core } from '@inter-ikea-core/core';
import { panelParts } from '../panelLayoutConfig';

const getPanelProductIds: (doorEntity: Core.Entity, coreApi: CoreApi) => string[] | null = (
  doorEntity,
  coreApi
) => {
  const childEntities = coreApi.entities
    .getDescendants(doorEntity)
    .map(productEntity => coreApi.entities.find(productEntity.entityId))
    .filter((e): e is Core.Entity => e !== null);
  const panelProductIds = panelParts
    .map(partKey => coreApi.entities.findEntityWithPartKey(childEntities, partKey))
    .filter(entity => entity !== null)
    .map(entity => coreApi.getRangeProductForEntity(entity!)?.id)
    .filter(productId => productId !== undefined) as string[];

  return panelProductIds.length === 8 ? panelProductIds : null;
};

export default getPanelProductIds;
